import request from '@/utils/request'


export function list(params){
    return request({
        url: 'admin/admin/AdminShop/list',
        method: 'get',
        params: params
    })
}

export function shop_set(params){
    return request({
        url: 'admin/admin/AdminShop/shop_set',
        method: 'get',
        params: params
    })
}

export function shop_get(params){
    return request({
        url: 'admin/admin/AdminShop/shop_get',
        method: 'get',
        params: params
    })
}
